var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _path19, _path20, _ellipse, _path21, _ellipse2, _path22, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 693 749",
    style: {
      enableBackground: "new 0 0 693 749"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4966B0;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E6E8EC;}\n\t.st3{fill:#4966B0;stroke:#4966B0;stroke-miterlimit:10;}\n\t.st4{fill:#3F3D56;}\n\t.st5{fill:url(#Path_190_1_);}\n\t.st12{fill:#FEB9B9;}\n\t.st7{fill:#2F2E41;}\n\t.st8{opacity:0.1;enable-background:new    ;}\n\t.st9{fill:#EFEFEF;}\n\t.st10{fill:#682CCB;}\n\t.st11{fill:#FEB9B9;stroke:#000000;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    transform: "translate(-282 -122.601)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(556.248 122.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_76",
    className: "st0",
    d: "M364.1,169.6h6.4c1.3,0,2.3,1,2.3,2.3v86c0,1.3-1,2.3-2.3,2.3h-6.4c-1.3,0-2.3-1-2.3-2.3 v-86C361.8,170.6,362.9,169.6,364.1,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_80",
    d: "M39,0h289.8c21.5,0,39,17.5,39,39v669.5c0,21.5-17.5,39-39,39H39c-21.5,0-39-17.5-39-39V39 C0,17.5,17.5,0,39,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    className: "st5",
    d: "M316.6,19.5h-42.2v5.1c0,13.3-10.8,24-24,24c0,0,0,0,0,0H116.2c-13.3,0-24.1-10.8-24.1-24 c0,0,0,0,0,0v-5.1H52.6c-16.1,0-29.2,13.1-29.2,29.2v650.2c0,16.1,13.1,29.2,29.2,29.2h264c16.1,0,29.2-13.1,29.2-29.2V48.7 C345.8,32.6,332.8,19.5,316.6,19.5C316.6,19.5,316.6,19.5,316.6,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_81",
    className: "st0",
    d: "M152.3,22.3h43.6c2.1,0,3.9,1.7,3.9,3.9v2.7c0,2.1-1.7,3.9-3.9,3.9h-43.6 c-2.1,0-3.9-1.7-3.9-3.9v-2.7C148.4,24.1,150.1,22.3,152.3,22.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    className: "st0",
    cx: 213.5,
    cy: 27.5,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    className: "st5",
    cx: 186.1,
    cy: 382.9,
    r: 69.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    className: "st3",
    d: "M277.6,373.2c0,51.4-41.6,93-93,93c-51.4,0-93-41.6-93-93s41.6-93,93-93 S277.6,321.8,277.6,373.2L277.6,373.2z M173.9,422.4l69-69c2.3-2.3,2.3-6.1,0-8.5c0,0,0,0,0,0l-8.5-8.4c-2.3-2.3-6.1-2.3-8.5,0 c0,0,0,0,0,0l-56.3,56.3l-26.3-26.3c-2.3-2.3-6.1-2.3-8.5,0l-8.5,8.5c-2.3,2.3-2.3,6.1,0,8.5l39,39 C167.8,424.8,171.6,424.8,173.9,422.4C173.9,422.5,173.9,422.5,173.9,422.4L173.9,422.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    transform: "translate(312.096 220.737)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_77",
    className: "st4",
    d: "M254.7,49.2h1c1.3,0,2.3,1,2.3,2.3v22.2c0,1.3-1,2.3-2.3,2.3h-1c-1.3,0-2.3-1-2.3-2.3V51.5 C252.4,50.2,253.4,49.2,254.7,49.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_78",
    className: "st4",
    d: "M254.5,98.3h1.7c1.3,0,2.3,1,2.3,2.3v42.1c0,1.3-1,2.3-2.3,2.3h-1.7c-1.3,0-2.3-1-2.3-2.3 v-42.1C252.2,99.3,253.2,98.3,254.5,98.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_79",
    className: "st4",
    d: "M254.6,161.3h1.4c1.3,0,2.3,1,2.3,2.3v42.5c0,1.3-1,2.3-2.3,2.3h-1.4c-1.3,0-2.3-1-2.3-2.3 v-42.5C252.3,162.3,253.3,161.3,254.6,161.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_190_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.0426,
    y1: 940.6741,
    x2: 5.0426,
    y2: 941.6811,
    gradientTransform: "matrix(1.216 0 0 -0.2879 173.1212 556.9154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.251
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.102
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    className: "st5",
    d: "M178.6,285.8c0.3,0.3,0.8,0.4,1.2,0.2C179.5,285.9,179,285.9,178.6,285.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    fill: "#ffb8b8",
    d: "M224.6,303.8l-1.2,6.5l-0.9,5l-1.7,9.1l-16.3,11.4c0,0-1.5-1.3-3.9-3.2 c-6.7-5.5-20.8-16.7-31.1-22.8c-2.7-1.7-5.5-3-8.5-3.9L224.6,303.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    className: "st4",
    d: "M212.6,308.6c0,0,19,3.3,20.2-4.9s-9.8-12.5-19-13.1s-64.8,3.3-64.8,3.3s-9.8,13.1,25.6,15.2 L212.6,308.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    x: 154.7,
    y: 40.3,
    className: "st7",
    width: 99.6,
    height: 118.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    x: 154.7,
    y: 40.8,
    className: "st8",
    width: 99.6,
    height: 118.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    fill: "#ffb8b8",
    d: "M37.9,242.5c-1.6,0.4-3.7,2-6.1,4.3C21.8,256.7,7.5,280,7.5,280c-18.4-21.9,2-39.2,10.6-45.1 c2.1-1.4,3.5-2.2,3.5-2.2L37.9,242.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    fill: "#ffb8b8",
    d: "M223.5,77.6c0,0,4.9,34.3,21.8,42.5s-21.8,23.4-21.8,23.4l-52.8-19.6c0,0,29.9-9.8,23.9-38.6 L223.5,77.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    fill: "#ffb8b8",
    d: "M166.9,283.9l-1.2,6.5l-1,5l-1.7,9.1L146.7,316c0,0-1.5-1.2-3.9-3.2 c-6.7-5.5-20.8-16.7-31.1-22.8c-2.7-1.7-5.5-3-8.5-3.9L166.9,283.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    className: "st7",
    d: "M152.8,291.9c0,0,17.1,0.1,18.1-8s-9.3-12.5-18.1-13.1s-62.3,3.5-62.3,3.5s-7.6,15.4,26.1,17.6 L152.8,291.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    className: "st4",
    d: "M272.6,420c-0.7-0.4-1.5-0.7-2.2-1.1l-2-2.5L242,382.9v0.6c-0.2,5.6-2.1,49.8-16.9,53.8 c-15.8,4.3-34.8,5.4-43.5-23.9s-24.5-93.6-40.8-97.4l24.2-19.9c0,0,16,18.8,22.6,36.7c-0.2-1.1-11.3-52.9-2.2-62h79.5 c0,0,12.3,34.9,20.7,52.3c6.5,13.4,16.4,45.2,22.7,66.7C314.5,411,292.5,429.8,272.6,420z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    className: "st8",
    d: "M270.3,280.6c-12.3,7.3-66.1,4.3-83.7,3.1l-4.8-0.3c-0.5,0,0.1-0.3,0.1-0.3l0.5-4.9l13.1-33.2 l69.9-40.6c-1.4,4.3-1.9,10.8-1.8,18.3C264,246.7,270.3,280.6,270.3,280.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    className: "st5",
    d: "M270.3,278.9c-12.3,7.3-66.1,4.3-83.7,3.1l-4.8-0.3l-0.8-0.1l0.9-0.2l4.3-1.1l9.2-37l69.9-40.5 c-1.4,4.3-1.9,10.8-1.8,18.3C264,245.1,270.3,278.9,270.3,278.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "st8",
    d: "M263.6,221.1c-14.2,3.3-45.5,12.9-57.5,36.1c-8,15.5-14.8,22.1-19.5,24.9l-4.8-0.3 c0-0.1,0.1-0.2,0.1-0.3l4.3-1.1l9.2-37l69.9-40.5C264,207,263.5,213.6,263.6,221.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    className: "st8",
    d: "M21.6,232.7l16.3,9.8c-1.6,0.4-3.7,2-6.1,4.3c-1.4-4-9.9-9.5-13.8-11.9 C20.2,233.5,21.6,232.7,21.6,232.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    className: "st8",
    d: "M178.9,282.4c-0.4,0.2-0.8,0.1-1.1-0.2C178.2,282.3,178.6,282.4,178.9,282.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    className: "st2",
    d: "M215.9,117.9c0,0-14.7,1.6-25-9.3c0,0-43.5,12.5-58.2,40.8S17.7,233.2,17.7,233.2 s17.4,9.8,15.8,14.7l65.9-38.1c0,0,23.4-16.9,29.9-20.7s42.5-27.2,50.1,36.5s0,56.1,0,56.1s10.9,3.8,26.7-26.7 s64.8-37.6,64.8-37.6l2.7-32.1c0,0,9.7-21.3,2.2-30.1c-2.3-2.6-3.8-5.8-4.4-9.2c-1.2-8.2,0-21.7,17.3-33 c26.7-17.4,37-31.6,37-31.6s0.5-10.4-15.8-15.2s-82.7-31.6-82.7-31.6l-2.2,9.3l52.4,37c0,0-26.1,21.2-46.8,20.7 C230.6,101.5,234.4,117.3,215.9,117.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    className: "st8",
    d: "M226,92.5c-1.3-4.4-2.3-8.8-3-13.3l-28.8,7.6c1.3,5.5,1,11.3-0.7,16.6 C205.5,106.7,218.3,102.4,226,92.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    fill: "#ffb8b8",
    cx: 202,
    cy: 71.9,
    r: 31
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    className: "st8",
    d: "M235.8,321.7c0,0,18,35.4,12.5,46.3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    className: "st7",
    d: "M218.5,0.2c8.6,1,16.8,4.7,25.3,6.7c2.1,0.7,4.4,0.7,6.5,0.2c3.3-1,6-4.5,9.4-4.4 c2.1,0.1,4,1.5,5.7,2.9c2.8,2.1,5.4,4.4,7.8,7c5.8,6.3,9.5,14.9,14.8,21.8s12.9,15,20.5,11.8c-5.2,20.1-21.2,32.6-39.5,33.9 c-7.3,0.5-14.7-1-21.8,1.1c-1.8,0.7-3.6,1.2-5.5,1.3c-4.1,0-7.3-3.7-9.9-7.4c-5.9-8.5-10.6-18.2-17.3-26c-2.2-2.6-4.8-5-7.9-5.5 s-6,1-8.8,2.5c-4.6,2.4-9.3,4.8-12.8,8.9s-5.8,10.1-4.3,15.6c0.8,3,2.6,5.6,2.6,8.7c0.1,5-4.3,8.6-5.2,13.4 c-0.2,2-0.3,4.1-0.2,6.1c-0.4,6.6-4.7,12-9.2,16.2c-1.8,1.6-3.7,3.3-4.2,5.8c-0.3,1.7,0,3.5-0.2,5.2c-0.7,4.3-4.9,6.5-8.7,7 c-4.4,0.7-8.9,0.1-13.1-1.5c5.3-2.5,8.5-9.6,7.3-16c-1.7-8.8-10.6-15.2-9.8-24.2c0.4-2.8,1.2-5.4,2.5-8c1.9-4.9,3.3-9.9,4.2-15.1 c0.7-4,1-8.2-0.3-12c-1.1-3.5-3.4-6.2-5.4-9.1c-2.7-4-4.8-8.3-6.3-12.9c-0.5-1.4-0.7-2.8-0.6-4.3c0.4-1.7,1.4-3.2,2.7-4.4 c4.9-5.1,10-10.4,16.5-11.9c3.1-0.5,6.3-0.6,9.4-0.4c5.4,0.2,10.9-0.1,16.3-0.7c4.5-0.5,12-0.5,15.8-3.3c3.5-2.7,5.5-6.1,9.8-7.8 C209.2,0.2,213.9-0.4,218.5,0.2L218.5,0.2z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9-2",
    className: "st5",
    cx: 495.2,
    cy: 866.5,
    rx: 29.7,
    ry: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179-2",
    className: "st5",
    d: "M507.5,858.3c1.4-1.1,2.3-2.6,2.8-4.3c0.4-1.7-0.4-3.5-2-4.3c-1.8-0.7-3.8,0.6-5.2,1.8 s-3.2,2.7-5.1,2.5c2-1.8,2.9-4.6,2.4-7.2c-0.1-0.5-0.3-1.1-0.7-1.5c-1-1.1-2.8-0.6-4,0.2c-3.8,2.7-4.9,7.9-4.9,12.6 c-0.4-1.7-0.1-3.5-0.1-5.2s-0.5-3.7-2-4.6c-0.9-0.5-1.9-0.7-3-0.7c-1.7-0.1-3.6,0.1-4.8,1.4c-1.5,1.6-1.1,4.2,0.2,5.9s3.2,2.8,5,4 c1.4,0.9,2.6,2,3.6,3.4c0.1,0.2,0.2,0.4,0.3,0.6h10.8C503.2,861.7,505.5,860.2,507.5,858.3L507.5,858.3z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    className: "st5",
    cx: 327.3,
    cy: 866.5,
    rx: 29.7,
    ry: 5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    className: "st5",
    d: "M339.6,858.3c1.4-1.1,2.3-2.6,2.8-4.3c0.4-1.7-0.4-3.5-2-4.3c-1.8-0.7-3.8,0.6-5.2,1.8 s-3.2,2.7-5.1,2.5c2-1.8,2.9-4.6,2.4-7.2c-0.1-0.5-0.3-1.1-0.7-1.5c-1-1.1-2.8-0.6-4,0.2c-3.8,2.7-4.9,7.9-4.9,12.6 c-0.4-1.7-0.1-3.5-0.1-5.2s-0.5-3.7-2-4.6c-0.9-0.5-1.9-0.7-3-0.7c-1.7-0.1-3.6,0.1-4.8,1.4c-1.5,1.6-1.1,4.2,0.2,5.9s3.2,2.8,5,4 c1.4,0.9,2.6,2,3.6,3.4c0.1,0.2,0.2,0.4,0.3,0.6h10.8C335.3,861.7,337.5,860.2,339.6,858.3L339.6,858.3z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    x: 282,
    y: 868.7,
    className: "st7",
    width: 902.6,
    height: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.7869a9a4824716d8df5c180999292857.svg";
export { ForwardRef as ReactComponent };